module.exports = __webpack_public_path__ + "img/VsLotion2.d83f0144.jpg";